import {IComponentOptions, ILogService, IWindowService} from "angular";
import {Application} from "../../shared/model/Application";
import "./student-dashboard.less";

class StudentDashboardController {
    public debug: boolean = false;
    public processing = false;
    public sortBy: string;
    public sortByOrder: string;
    public sortReverse = true;
    public defaultSortBy: string = "updated";
    public defaultSortByOrder: string = "-updated";

    public applications: Application[];


    /* @ngInject */
    constructor(private $log: ILogService,
                private $window: IWindowService,
                private $state: any,
               ) {
    }

    public $onInit() {
        if (this.applications === null || this.applications.length === 0) {
            this.$state.go("student.application");
        }

        this.setDefaultSortOrder();
    }

    public setSortBy(sortBy: string) {
        if (this.sortBy === sortBy && !this.sortReverse) {
            // User selected to sort by status second time. Switch to default sort order
            this.sortReverse = true;
        } else if (this.sortBy === sortBy && this.sortReverse) {
            this.setDefaultSortOrder();
        } else {
            this.sortBy = sortBy;
            this.sortReverse = false;
        }

        this.sortByOrder = (!this.sortReverse ? "" : "-") + this.sortBy;
    }

    private setDefaultSortOrder() {
        this.sortBy = this.defaultSortBy;
        this.sortByOrder = this.defaultSortByOrder;
        this.sortReverse = true;
    }
}

export const StudentDashboardComponent: IComponentOptions = {
    bindings: {
        applications: "<"
    },
    controller: StudentDashboardController,
    template: require("./student-dashboard.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/student/dashboard/student-dashboard.component.ts